
import {AgGridVue} from "ag-grid-vue";

import HttpFactory from '@/mixins/http.factory';
export default {
	name: 'custom-ag-grid',
	mixins:[HttpFactory],
	props:{
		id: {
			type: String,
			required: false,
			default: () => null
		},
		rowSelection:{
			type: String,
			required: false,
			default: () => 'single'
		},
		gridHeight: {
			type: Number,
			required: false,
			default: () => null
		},
		domLayout: {
			type: String,
			required: false,
			default: () => 'autoHeight'
		},
		headerCols: {
			type: Array,
			required: true,
			default: () => []
		},
		cacheData: {
			type: Object,
			required: false,
			default: () => null
		},
		dataItems: {
			type: Array,
			required: true,
			default: () => []
		},
		pinnedTopRowData: {
			type: Array,
			required: false,
			default: () => null
		},
		editType: {
			type: String,
			required: false,
			default: () => null
		},
		suppressClickEdit: {
			type: Boolean,
			required: false,
			default: () => false
		},
		autoSizeColumns: {
			type: Boolean,
			required: false,
			default: () => true
		},
		refreshAutoSizeColumns: {
			type: Boolean,
			required: false,
			default: () => false
		},
		sizeColumnsToFit: {
			type: Boolean,
			required: false,
			default: () => true
		},
		showHRScroll: {
			type: Boolean,
			required: false,
			default: () => true
		},
		showLoadingGrid: {
			type: Boolean,
			required: false,
			default: () => true
		},	
		rowHeight: {
			type: Number,
			required: false,
			default: () => null
		},
		pageSize: {
			type: Number,
			required: false,
			default: () => 10
		},
		pagination: {
			type: Boolean,
			required: false,
			default: () => true
		},
		rowModelType: {
			type: String,
			required: false,
			default: () => null
		},
		cacheBlockSize: {
			type: Number,
			required: false,
			default: () => 10
		},
		allowRowClass: {
			type: Boolean,
			required: false,
			default: () => false
		},	
		rowHeighlightClass: {
			type: Object,
			required: false,
			default: () => null
		},	
		defaultColDefProp: {
			type: Object,
			required: false,
			default: () => null
		},		
		userFilterCache: {
			type: Boolean,
			required: false,
			default: () => false
		},	
		cacheName: {
			type: String,
			required: false,
			default: () => null
		},
		treeData: {
			type: Boolean,
			required: false,
			default: () => false
		},
		autoGroupColumnDef: {
			type: Object,
			required: false,
			default: () => null
		},
		groupDefaultExpanded: {
			type: Number,
			required: false,
			default: () => 0
		},
		groupSelectsChildren: {
			type: Boolean,
			required: false,
			default: () => false
		},
		rowSelection: {
			type: String,
			required: false,
			default: () => 'single'
		},
	},
	data () {
		return {
			gridId:null,
			gridOptions:null,
			domLayoutD:null,
			setRowHeight:50,
			gridColumnDefs:[],
			rowData:[],
			gridApi : null,
			gridColumnApi : null,
			autoSizeColumns_data:null,
			sizeColumnsToFit_data:null,
			mobileView:{columnDefs:[],dataItems:[]},
			defaultColDef:{sortable: true,filter: true},
			showEvenOddBg:false,
			overlayLoadingTemplate:'<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
  			overlayNoRowsTemplate:'<span class="ag-overlay-loading-center">There are no rows to display</span>',
		}
	},
	watch: {
		headerCols:function(newData,oldData){
			let _self=this;
			_self.headerCols=newData;
		},
		dataItems:function(newData,oldData){
			let _self=this;
			_self.dataItems=newData;
			_self.applyAgGrid(true);
		},
		showLoadingGrid:function(newData,oldData){
			let _self=this;
			_self.showLoadingGrid=newData;
			_self.globalLoadingHandle(true);
		},
		autoGroupColumnDef:function(newData,oldData){
			let _self=this;
			_self.autoGroupColumnDef=newData;
		},
		autoSizeColumns:function(newData,oldData){
			let _self=this;
			_self.autoSizeColumns=newData;
			_self.sizeColumnsToFit=_self.autoSizeColumns?false:true;
			_self.applyWindowResizeFn();
		},
		sizeColumnsToFit:function(newData,oldData){
			let _self=this;
			_self.sizeColumnsToFit=newData;
			_self.autoSizeColumns=_self.sizeColumnsToFit?false:true;
			_self.applyWindowResizeFn();
		},
		refreshAutoSizeColumns:function(newData,oldData){
			let _self=this;
			// _self.refreshAutoSizeColumns=newData;
			// _self.applyWindowResizeFn();
		},
	},
	created(){
		let _self=this;
		_self.init();
	},
	mounted(){
		let _self=this;
		
	},
	methods: {
		init(){
			let _self=this;
			_self.gridId=_self.id?_self.id:0;
			_self.gridId=Math.random()+'_'+_self.gridId;
			_self.gridColumnDefs=_self.headerCols;
			_self.setRowHeight=_self.rowHeight?_self.rowHeight:_self.setRowHeight;
			_self.defaultColDef=_self.defaultColDefProp?_self.defaultColDefProp:_self.defaultColDef;
			_self.autoSizeColumns_data=_self.autoSizeColumns;
			_self.sizeColumnsToFit_data=_self.sizeColumnsToFit;
		},
		handleHeaderToolTip(){
			let _self=this;
			let headerCols=_self.headerCols;
			for(var i=0; i<headerCols.length;i++){
				headerCols[i].headerTooltip=headerCols[i].headerName;
				headerCols[i].resizable=headerCols[i].resizable==undefined?true:headerCols[i].resizable;
				headerCols[i].sortable=headerCols[i].sortable==undefined?true:headerCols[i].sortable;
				if(_self.userFilterCache){
					headerCols[i].filter=headerCols[i].filter?headerCols[i].filter:'agTextColumnFilter';
				}
			}
		},	
		onShowLoading() {
			if(this.gridApi)
				this.gridApi.showLoadingOverlay();
		  },
		onShowNoRows() {
			let _self=this;
			if(_self.gridApi){
				setTimeout(function(){
					_self.gridApi.showNoRowsOverlay();
					//_self.gridApi.hideOverlay();
				},2000);
			}
		  },
		onHide() {
			let _self=this;
			if(_self.gridApi){
				setTimeout(function(){
					_self.gridApi.hideOverlay();
				},2000);
			}
		},
		globalLoadingHandle(watchCallBack){
			let _self=this;
			if(watchCallBack){
				if(_self.showLoadingGrid)
					_self.onShowLoading();
				else if(_self.dataItems.length>0 && !_self.showLoadingGrid)
					_self.onHide();
				else if(_self.dataItems.length<=0 && !_self.showLoadingGrid){
					_self.onShowNoRows();
				}
			}
		},
		applyAgGrid(watchCallBack){
			let _self=this;
			_self.applyWindowResizeFn();
			_self.globalLoadingHandle(watchCallBack);
		},
		onCellEditingStarted(event){
			let _self=this;
			_self.$emit('onCellEditingStarted',event);
		},
		rowClicked(params){
			let _self=this;
			_self.$emit('rowClicked',params);
		},
		rowGroupOpened(params){
			let _self=this;
			_self.$emit('rowGroupOpened',params);
		},
		serverSideDatasource(gridParams,contextO) {
            return {
              getRows: function(params) {
				let pageSize=gridParams.api.paginationGetPageSize();
				let filterModel=gridParams.api.getFilterModel();
				let sortModel=gridParams.api.getSortModel();
				contextO.$emit('AgServerSideData',params,pageSize,filterModel,sortModel);
              }
            };
        },
		onAgGridReady(params) {
			let _self=this;
			_self.gridApi = params.api;
			_self.gridColumnApi = params.columnApi;
			if(_self.showLoadingGrid)
				_self.onShowLoading();
			
			_self.windowsResizeFn();
			if(_self.rowModelType=='serverSide'){
				var datasource =new _self.serverSideDatasource(params,_self);
				params.api.setServerSideDatasource(datasource);
			}
			_self.$emit('onAgGridReady',params);
			_self.$emit('onGridOptionsApi',_self.gridOptions)
		} ,
		onAgGridFirstDataRendered(params) {
			let _self=this;
			//re-draws the ag-grid component to fit the screen
			// if(this.autoSizeColumns)
			// 	params.api.sizeColumnsToFit();
			// var allColumnIds = [], ignoreCols = ["qtlNote", "qtlInternalNote", "pricngParams"];
			// this.gridColumnApi.getAllColumns().forEach(function (column) {
			//     if (ignoreCols.indexOf(column.colId) == -1)
			//         allColumnIds.push(column.colId);
			// });
			_self.globalColumnsResize();
			if(_self.userFilterCache){
				_self.applyCachedFilterSort(params);
			}
		},
		applyCachedFilterSort(params){
			let _self=this;
			let filterModel=sessionStorage[`${_self.cacheName}_filter`]?JSON.parse(sessionStorage[`${_self.cacheName}_filter`]):null;
			let sortModel=sessionStorage[`${_self.cacheName}_sort`]?JSON.parse(sessionStorage[`${_self.cacheName}_sort`]):null;
			if(filterModel){
				params.api.filterManager.setFilterModel(filterModel);
			}
			if(sortModel){
				params.api.setSortModel(sortModel);
			}
		},
		onAgGridFilterChanged(params) {
			let _self = this;
			////https://www.ag-grid.com/javascript-grid-filtering/
			let filterModel=JSON.stringify(params.api.filterManager.getFilterModel());
			sessionStorage[`${_self.cacheName}_filter`]=filterModel;
      		this.$emit('onAgGridFilterChanged',params);
		},
		onAgGridSortChanged(params) {
			let _self = this;
			let sortModel=JSON.stringify(params.api.getSortModel())
			sessionStorage[`${_self.cacheName}_sort`]=sortModel;
			this.$emit('onAgGridSortChanged',params);
		},
		onAgGridSelectionChanged(data) {
			let _self = this;
			// let selectedRow = data.api.getSelectedRows();
			// if(selectedRow.length == 0) return;
			// let selectedLine = selectedRow[0];
			// selectedLine.rowIndex=data.api.getSelectedNodes()[0].rowIndex;
			this.$emit('onAgGridSelectionChanged',data);
		},
		onAgGridRowValueChanged(params){
			let _self=this;
			_self.$emit('onAgGridRowValueChanged',params);
		},
		onRowEditStartedFn(params){
			let _self=this;
			_self.$emit('onRowEditStartedFn',params);
		},
		onCellValueChanged(params){
			let _self=this;
			this.$emit('onCellValueChanged',params,_self.cacheData);
		},
		paginationChanged(params){
			let _self=this;
			this.$emit('paginationChanged',params);
		},
		showConfirmItemDelPopFn(params){
			this.$emit('showConfirmItemDelPopFn',params);
		},
		refreshUser(params){
			this.$emit('refreshUser',params);
		},
		extraCallBackFn(params){
			this.$emit('extraCallBackFn',params);
		},
		editDataRowFn(params){
			this.$emit('editDataRowFn',params);
		},
		//2nd grid temp
		onCellValueChanged1(params){
			let _self=this;
			this.$emit('onCellValueChanged1',params,_self.cacheData);
		},
		showConfirmItemDelPopFn1(params){
			this.$emit('showConfirmItemDelPopFn1',params,this.cacheData);
		},
		extraCallBackFn1(params){
			this.$emit('extraCallBackFn1',params);
		},

		//3rd grid temp
		onCellValueChanged2(params){
			let _self=this;
			this.$emit('onCellValueChanged2',params);
		},
		showConfirmItemDelPopFn2(params){
			this.$emit('showConfirmItemDelPopFn2',params);
		},
		extraCallBackFn2(params){
			this.$emit('extraCallBackFn2',params,this.cacheData);
		},

		//4rd grid temp
		onCellValueChanged3(params){
			let _self=this;
			this.$emit('onCellValueChanged3',params);
		},
		showConfirmItemDelPopFn3(params){
			this.$emit('showConfirmItemDelPopFn3',params);
		},
		extraCallBackFn3(params){
			this.$emit('extraCallBackFn3',params);
		},
		extraCallBackFn4(params){
			this.$emit('extraCallBackFn4',params);
		},
		extraCallBackFn5(params){
			this.$emit('extraCallBackFn5',params);
		},
		extraCallBackFn6(params){
			this.$emit('extraCallBackFn6',params);
		},
		extraCallBackFn7(params){
			this.$emit('extraCallBackFn7',params);
		},
		extraCallBackFn8(params){
			this.$emit('extraCallBackFn8',params);
		},
		extraCallBackFn9(params){
			this.$emit('extraCallBackFn9',params);
		},
		extraCallBackFn10(params){
			this.$emit('extraCallBackFn10',params);
		},
		editCustomerConfig(params){
			this.$emit('editCustomerConfig',params);
		},
		windowsResizeFn(){
			let _self=this;
			_self.applyWindowResizeFn();
			window.addEventListener('resize', function () {
				setTimeout(function () {
					_self.applyWindowResizeFn();
				});
			})
		},
		globalColumnsResize(){
			let _self=this;
			if(!_self.gridColumnApi) return;
			//_self.gridApi.sizeColumnsToFit();
			
			if(_self.autoSizeColumns_data){
				_self.gridColumnApi.autoSizeColumns(_self.gridColumnApi.getAllColumns());
			}
			if(_self.sizeColumnsToFit_data){
				_self.gridApi.sizeColumnsToFit();
			}
		},
		applyWindowResizeFn(){
			let _self=this;
			_self.rowData=_self.dataItems;
			if(!_self.gridApi || !_self.gridOptions || !_self.gridOptions.api)return;
			if (window.innerWidth <= 480) {
				//_self.generateMobileView(1,refreshParams);
				_self.autoSizeColumns_data=true;
				_self.sizeColumnsToFit_data=false;
				console.log('mobile view');
			}else if (window.innerWidth > 480 && window.innerWidth<=812) {
				//_self.generateMobileView(2,refreshParams);
				_self.autoSizeColumns_data=true;
				_self.sizeColumnsToFit_data=false;
			}else{
				//_self.showEvenOddBg=false;
				//_self.rowData=_self.dataItems;
				//_self.gridColumnDefs=_self.headerCols;
				//_self.gridApi.refreshCells(refreshParams);
				//console.log('normal view called');
				_self.autoSizeColumns_data=_self.autoSizeColumns;
				_self.sizeColumnsToFit_data=_self.sizeColumnsToFit;
			}
			_self.globalColumnsResize();
		},
		generateMobileView(colsCount,refreshParams){
			let _self=this;
			//cols
			let mobileColumnDefs=[];
			for(var i=0; i<colsCount;i++){
				mobileColumnDefs.push({ headerName: 'Name', field: `displayName${i}`,headerTooltip:'Name', cellClass:'' })
				mobileColumnDefs.push({ headerName: 'Value', field: `displayValue${i}`,headerTooltip:'Value',cellClass:''
				,editable:_self.headerCols[0].editable });
			}

			//items
			let dataItems=_self.dataItems;
			let mobileDataItems=[];
			for(var i=0;i<dataItems.length;i++){
				//let dataRow=dataItems[i];	
				let keys=Object.keys(dataItems[i]);
				let tempColIndex=0;
				let dataRow={};
				for(var j=0; j<keys.length; j++) {
					let displayCol=_self.headerCols.filter(d=>d.field==keys[j])[0];
					if(displayCol){
						if(tempColIndex<colsCount){
							dataRow[`displayName${tempColIndex}`]=displayCol.headerName;
							dataRow[`displayValue${tempColIndex}`]=dataItems[i][keys[j]];
							tempColIndex++;
						}
						if(tempColIndex==colsCount && !_self.fn().isJSONEmpty(dataRow)){
							dataRow.custRowIndex=i;
							let n={..._self.jsonConcat(dataItems[i],dataRow)};
							mobileDataItems.push(n);
							tempColIndex=0;
							dataRow={};
						}
					}
					
				}
			}
			_self.mobileView={columnDefs:mobileColumnDefs,dataItems:mobileDataItems};
			
			//actual
			_self.rowData=_self.mobileView.dataItems;
			_self.gridColumnDefs=_self.mobileView.columnDefs;
			_self.showEvenOddBg=true;
			_self.gridApi.refreshCells(refreshParams);
		},
		getGridHeight(){
			let _self=this;
			let gridHeight=_self.domLayoutD=='normal'?(_self.rowData.length>0?(_self.gridHeight?_self.gridHeight:400):120):null;
			return gridHeight?`height:${gridHeight}px`:'';
		}

	},
	components:{
    	AgGridVue
  	},
  	beforeMount() {
		let _self  =this;
		_self.domLayoutD=_self.domLayout;
		let gridOptions = {
			context: {
				componentParent: this
			},
			rowSelection:_self.rowSelection,
			groupSelectsChildren:_self.groupSelectsChildren,
			//enableCellTextSelection:true,
			// getRowHeight: function (params) {
			//     let minHeight = 50, h = 5, nlen = 0, intlen = 0;
			//     nlen = params.data.qtlNote ? params.data.qtlNote.length : 0;
			//     intlen = params.data.qtlInternalNote ? params.data.qtlInternalNote.length : 0;
			//     if (nlen > intlen)
			//         h = 18 * (M-ath.floor(nlen / 45) + 1);
			//     else
			//         h = 18 * (Math.floor(intlen / 45) + 1);
			//     return (minHeight > h ? minHeight : h);
			// }
		};
		if(_self.allowRowClass){
			gridOptions.getRowClass=function(params){	
				let rowHeighlightClass=_self.rowHeighlightClass;
				if(rowHeighlightClass && rowHeighlightClass.matchType=='col' && params.data[rowHeighlightClass.colName]==rowHeighlightClass.colVal && params.data['completedOn']==null){
					return rowHeighlightClass.className;
				}
				if(rowHeighlightClass && rowHeighlightClass.type=='history'
				&& (params.data.stepNumber!=params.data.stepToBe && params.data.stepToBe!=null)){
					return 'bg-pink';
				}
				if(rowHeighlightClass && rowHeighlightClass.className) return rowHeighlightClass.className;
			}
		}
		if(_self.showEvenOddBg){
			gridOptions.getRowClass=function(params){	
				if(params.data.custRowIndex==undefined)return;
				return (params.data.custRowIndex % 2 == 0)?'bg-light-gray':'';
			}
		}
		if(_self.suppressClickEdit){
			gridOptions.suppressClickEdit=_self.suppressClickEdit;
		}
		if(_self.autoGroupColumnDef){
			_self.autoGroupColumnDef.resizable=true;
		}
		if(_self.treeData){
			gridOptions.treeData=_self.treeData;
			gridOptions.autoGroupColumnDef=_self.autoGroupColumnDef;
			gridOptions.groupDefaultExpanded=_self.groupDefaultExpanded,
			gridOptions.getDataPath=function(data) {
				return data.orgHierarchy;
			}
		}
		
		//gridOptions.suppressRefresh=true;
		_self.gridOptions=gridOptions;
		_self.handleHeaderToolTip();
		_self.gridColumnDefs=_self.headerCols;
		_self.applyAgGrid();
  	}
}